<template>
    <q-card flat >

   <!-- <div class="q-pa-sm text-caption text-right print-hide">About these data <q-icon name="help_outline" class="q-pl-sm pointer" size="xs"   @click="infoDialogs['about'].model = !infoDialogs['about'].model"/></div> -->

        <div id="otherActivityPane" v-bind="attrs" class="q-pl-md q-pr-md">
            <div class="justify-center" v-if="finalData" >
                <!-- <div class="row  text-body1 text-bold justify-start text-left text-uppercase underline">Sand Extraction</div>
                <div class="justify-center items-center pointer"   >
                    <div class="row q-pl-sm"                 
                        @click="otherAttrClick('SAND', 'Sand')"
                        :class="'SAND' === mapStyleInfo['attr'] ? 'highlight shadow-1' :  ''"
                        >
                        <div class="col-1" >
                            <q-icon v-if="finalData['sand']['SAND'].includes(1)" name="check_circle" size="xs" color="secondary"></q-icon>
                            <q-icon class="self-center" name="cancel" size="xs" v-else />
                        </div>
                        <div class="col-7">{{ sandValueNames[1] }}</div>
                        <div class="col-1">
                            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click.stop="dataConsiderations['aliquotsSand'].model = !dataConsiderations['aliquotsSand'].model" aria-label="Aliquopts sand data help"/>
                        </div>
                        <div class="col-3"></div>

                        <div class="col-1" >
                            <q-icon v-if="finalData['sand']['SAND'].includes(2)" name="check_circle" size="xs" color="secondary"></q-icon>
                            <q-icon class="self-center" name="cancel" size="xs" v-else />
                        </div>
                        <div class="col-7">{{ sandValueNames[2] }}</div>
                        <div class="col-1">
                            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click.stop="dataConsiderations['boemSand'].model = !dataConsiderations['boemSand'].model" aria-label="BOEM sand data help"/>
                        </div>
                    </div>
                </div> -->
                <div class="row  text-body1 text-bold justify-start text-left text-uppercase underline">Sand Extraction</div>
                <div class="justify-center items-center pointer"   >
                    <div class="row q-pl-sm"                 
                        @click="otherAttrClick('SAND', 'Sand')"
                        :class="'SAND' === mapStyleInfo['attr'] ? 'highlight shadow-1' :  ''"
                        >
                        <div class="col-10">
                            <div class="row">
                                <div class="col-1" >
                                    <q-icon v-if="finalData['sand']['SAND'].includes(1)" name="check_circle" size="xs" color="secondary"></q-icon>
                                    <q-icon class="self-center" name="cancel" size="xs" v-else />
                                </div>
                                <div class="col-10">{{ sandValueNames[1] }}</div>
                                <div class="col-1">
                                    <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click.stop="dataConsiderations['aliquotsSand'].model = !dataConsiderations['aliquotsSand'].model" aria-label="Aliquopts sand data help"/>
                                </div>
                    

                                <div class="col-1" >
                                    <q-icon v-if="finalData['sand']['SAND'].includes(2)" name="check_circle" size="xs" color="secondary"></q-icon>
                                    <q-icon class="self-center" name="cancel" size="xs" v-else />
                                </div>
                                <div class="col-10">{{ sandValueNames[2] }}</div>
                                <div class="col-1">
                                    <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click.stop="dataConsiderations['boemSand'].model = !dataConsiderations['boemSand'].model" aria-label="BOEM sand data help"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 items-center self-center bordered pointer q-ml-sm" 
                            :class="mapStyleInfo['attr'] == 'SAND' ? 'mapActive' : ''"  
                                @click="otherAttrClick('SAND', 'Sand')">
                            <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'SAND'" name="play_arrow"></q-icon>
                            <q-icon  class="self-center q-pb-md" v-else name="star" color="white" ></q-icon>
                            <q-tooltip>Display cable data in the map</q-tooltip>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row text-body1 text-bold q-pt-lg text-uppercase underline">Wind Energy Cables</div>
            <div class="row justify-start"  v-if="finalData">
                <div class="col-5 q-pa-sm"  v-for="(name, attr) in cableAttrNames" :key="attr" :class="attr === mapStyleInfo['attr'] ? 'highlight shadow-1' :  ''"> 
                    <div class="row items-center">
                        <span class="text-bold">{{ name }} </span>
                        <div class="col-1">
                            <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="dataConsiderations[attr].model = !dataConsiderations[attr].model" aria-label=" data help"/>
                        </div>
                    </div>
                    <div @click="otherAttrClick(attr, name)" class="pointer">
                        <div class="row  justify-center items-center" >
                            <div class="col-2" >
                                <q-icon name="check_circle" size="xs" color="lime-5" v-if="finalData['cables'][attr].includes(1)"></q-icon>
                                <q-icon class="self-center" name="cancel" size="xs" v-else />
                            </div>
                            <div class="col-8">
                                Planned
                            </div>
                        </div>
                        <div class="row  justify-center items-center"  >
                            <div class="col-2">
                                <q-icon name="check_circle" size="xs" color="primary" v-if="finalData['cables'][attr].includes(2)"></q-icon>
                                <q-icon class="self-center" name="cancel" size="xs" v-else />
                            </div>
                            <div class="col-6">
                                Installed
                            </div>
                            <div class="col-2 bordered pointer q-mb-lg" 
                                :class="mapStyleInfo['attr'] == attr ? 'mapActive' : ''"  
                                @click="otherAttrClick(attr, 'Export Cables')">
                                <q-icon class="q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != attr" name="play_arrow"></q-icon>
                                <q-icon  class="q-pb-md" v-else name="star" color="white" ></q-icon>
                                <q-tooltip>Display cable data in the map</q-tooltip>
                            </div>
                        </div>

                    </div>



                </div>
            </div>
            <div class="justify-center q-pt-lg" v-if="finalData" >
                <div class="row  text-body1 text-bold justify-start text-left q-pt-md text-uppercase underline">Other Uses</div>
                <div class=" items-center pointer"  
                    v-for="(name, attr) in presAttrNames" :key="attr"  >
                    <div class="row q-pa-xs"                
                        @click="otherAttrClick(attr, name)"
                        :class="attr === mapStyleInfo['attr'] ? 'highlight shadow-1' :  ''"
                        >
                        <div class="col-1" >
                            <q-icon v-if="finalData['present'][attr]" name="check_circle" size="xs" color="secondary"></q-icon>
                            <q-icon class="self-center" name="cancel" size="xs" v-else />
                        </div>
                        <div class="col-3">{{ name }}</div>
                        <div class="col-6">
                            <q-btn dense size="xs" flat class="gray " icon="help_outline" @click.stop="dataConsiderations[attr].model = !dataConsiderations[attr].model" aria-label="other uses data help"/>
                        </div>
                        <div class="col-1 items-center self-center bordered pointer q-ml-md" 
                            :class="mapStyleInfo['attr'] == attr ? 'mapActive' : ''"  
                            @click="otherAttrClick(attr, name)">
                            <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != attr" name="play_arrow"></q-icon>
                            <q-icon  class="self-center q-pb-md" v-else name="star" color="white" ></q-icon>
                            <q-tooltip>Display cable data in the map</q-tooltip>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row  text-body1 text-bold justify-start text-left q-pt-lg text-uppercase">
                <span class="underline">Shipping and Commercial Fishing</span>
                <q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click.stop="dataConsiderations['shipping'].model = !dataConsiderations['shipping'].model, dataConsiderations['commFishing'].model = !dataConsiderations['commFishing'].model" aria-label="BOEM sand data help"/>

                <!-- <q-btn dense size="xs" flat class="gray q-mb-xs" icon="help_outline" @click="infoDialogs['shipping'].model = !infoDialogs['shipping'].model" aria-label="Shipping and commercial fishing data help"/> -->
            </div>
            <div class="text-caption">The visualization below shows the estimated level of overall shipping and commercial fishing throughout the year. This is based on Automatic Identification System (AIS) data for 2023. Note that only ships that have AIS onboard are included. For commercial fishing, this may underestimate overall fishing occurring in the area.  Click on each month's bubble to view the map. </div>
            <div class="row q-mt-sm q-pb-sm" v-if="finalData">
                <Table 
                    :version="version"
                    :rows="finalData['months']" 
                    :columns="columns"
                    title=""
                    :expandRows="false"
                    :mapStyle="true"
                    :mapStops="stops['spp_1_50_75_90']"
                    :mapClassNames="legendColorStopNames"
                    :cellColors="tableCellColors"
                    :labelCells="false"
                    mapLayer="PEOPLE_OTHER"
                    :mapLegendTitles="aisLegendTitles"
                    :includeFilter="false"
                    :flat="true"
                    :hide-pagination="true"
                ></Table>
            </div>
        </div>
    </q-card>
    
    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
    <div v-for="(infoObj, name) in dataConsiderations" :key="name" >
      <q-dialog v-model="infoObj.model">
          <q-card>
          <q-card-section>
              <PeopleDataConsiderations :groupsToShow="name" />
          </q-card-section>
          <q-card-actions align="right">
              <q-btn flat label="OK" color="primary" @click="infoObj.model = false" />
          </q-card-actions>
          </q-card>
      </q-dialog>
  </div>
</template>
<script setup lang="ts">
import { toRefs, ref, computed, onMounted, useAttrs } from "vue";
import { QTableColumn } from 'quasar';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { stops, dqStops } from "../assets/ColorStops.json"
import InfoDialog from "./InfoDialog.vue";
import Table from "./Table.vue";
import PeopleDataConsiderations from "./PeopleDataConsiderations.vue";
const {  styleMap, processedData, setProcessedData, loadDataByID, activeLayerID, setLegend, mapStyleInfo } = useMapItems()
const {  months } = useHelpers();
const attrs = useAttrs();

const props = defineProps({
    rawData: { type: Object },
    version: {type: Number}
})

const { rawData, version } = toRefs(props)

const otherData =  computed(() =>{
    if (rawData.value && rawData.value["PEOPLE_OTHER"] && rawData.value["PEOPLE_OTHER"].length >0){
        return rawData.value["PEOPLE_OTHER"]
    }
    else{ return null}
})


const finalData = computed(() => {
    const finalData = {}
    const monthData = [];
    const presData = {}
    interface CableData {
        [key: string]: number[];
    }
    const cableData: CableData ={}
    const finalCableData = {}

    interface SandData {
        [key: string]: number[];
    }
    const sandData: SandData ={}
    const finalSandData = {}

    if (
        !processedData.value[version.value] || 
        processedData.value[version.value]['PEOPLE_OTHER'] === undefined ||
        processedData.value[version.value]['PEOPLE_OTHER']['a'] === undefined ||
        processedData.value[version.value]['PEOPLE_OTHER']['a']['a'] === undefined
    ){
        if (otherData.value) {
            // initialize to false
            presAttrs.forEach((attr) =>{
                presData[attr] = false;
            })
            cableAttrs.forEach((attr) =>{
                cableData[attr] = [];
            })

            sandData['SAND'] = []

            otherData.value.forEach((cell) => {
                // AIS & Fishing data
                const attrs = ["AIS", "FIS"];
                attrs.forEach((attr) => {
                    const attrObj = monthData.find(obj => obj.id === attr) || { id: attr, name: aisNames[attr] };
                    Object.entries(months).forEach(([code, monthName]) => {
                        const a = `${attr}_${monthName.toUpperCase()}`;
                        if (!attrObj[monthName] || cell[a] > attrObj[monthName]) {
                            attrObj[monthName] = cell[a];
                        }
                    });
                    if (!monthData.includes(attrObj)) {
                        monthData.push(attrObj);
                    }
                });

                presAttrs.forEach((attr) =>{
                    if (cell[attr] === 1){
                        presData[attr] = true;
                    }
                })
                            
                cableAttrs.forEach((attr) =>{
                    cableData[attr].push(cell[attr])
                })

                sandData['SAND'].push(cell['SAND'])

            });
            Object.entries(cableData).forEach(([attr, valArr]) => {
                finalCableData[attr] = Array.from(new Set(valArr))
            })

    
            finalSandData['SAND'] = Array.from(new Set(sandData['SAND']))
              
            
            finalData['months'] = monthData
            finalData['present'] = presData
            finalData['cables'] = finalCableData
            finalData['sand'] = finalSandData

            setProcessedData(version.value, "PEOPLE_OTHER", 'a', 'a', finalData)
            return finalData
        }
        else{
            return null
        }
    }
    else{
        // console.log("Loading ", processedData.value[version.value]['PEOPLE_OTHER']['a']['a'])
        return processedData.value[version.value]['PEOPLE_OTHER']['a']['a']
    }


});

const presAttrs = ["ART", "PIPE"]
const cableAttrs = ["CABE", "CABI"]

const presAttrNames = {
    "ART" :"Artificial Reefs",
    "PIPE": "Pipelines"
}

const sandValueNames = {
    1 : "OCS Aliquots with sand resources",
    2 : "BOEM Sand Resources"
}

const cableAttrNames = {
    "CABE" : "Export cables", 
    "CABI" : "Inter-array cables"
}
const aisNames = {
    "AIS" : "Overall Shipping",
    "FIS" : "Comm. Fishing"
}

const otherAttrClick = (attr, name) =>{
    // console.log(attr)
    let catNames 
    let colors 
    if (cableAttrs.includes(attr)){
        colors = stops['cables']
        catNames =  {
            "2" : "Installed",
            "1" : "Planned",
            "0" : "Absent"
        }
    }
    else if (presAttrs.includes(attr)){
        colors = stops['sighting']
        catNames =  {
            "1" : "Present",
            "0" : "Absent"
        }
    }
    else if (attr == 'SAND'){
        colors = stops['cables'] // can use same symbology
        catNames =  {
            "1" : sandValueNames[1],
            "2" : sandValueNames[2],
            "0" : "No known sand resources"
        }
    }
    styleMap(activeLayerID.value, attr, 'categorical',colors, catNames), 
    setLegend(name , colors, catNames)
}

const columns: QTableColumn[] = [
    { name: 'name', required: true, label: '', align: 'left',field: 'name', sortable: true, style: 'padding-left: 3px; width: 55px; max-width: 55px;'  },
    { name: 'Jan', align: 'center', label: 'Jan', field: 'Jan', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;'  },
    { name: 'Feb', align: 'center', label: 'Feb', field: 'Feb', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Mar', align: 'center', label: 'Mar', field: 'Mar', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Apr', align: 'center', label: 'Apr', field: 'Apr', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'May', align: 'center', label: 'May', field: 'May', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jun', align: 'center', label: 'Jun', field: 'Jun', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jul', align: 'center', label: 'Jul', field: 'Jul', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Aug', align: 'center', label: 'Aug', field: 'Aug', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Sep', align: 'center', label: 'Sep', field: 'Sep', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Oct', align: 'center', label: 'Oct', field: 'Oct', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Nov', align: 'center', label: 'Nov', field: 'Nov', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Dec', align: 'center', label: 'Dec', field: 'Dec', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
 ]

 const legendColorStopNames ={
    '-9' : "No Data",
    "1" : "Low",
    "50" : "Medium", 
    "75" : "High", 
    "90" : "Very High"
}
const tableCellColors ={
    "90" : "#830C5D",
    "75" : "#F16DC6",
    "50" : "#EEB3DA",
    "1" : "#fae3f2",
    "-9" : "#a1a1a1"
}


const aisLegendTitles = {
    "Jan" : " (Jan)",
    "Feb" : " (Feb)",
    "Mar" : " (Mar)",
    "Apr" : " (Apr)",
    "May" : " (May)",
    "Jun" : " (Jun)",
    "Jul" : " (Jul)",
    "Aug" : " (Aug)",
    "Sep" : " (Sep)",
    "Oct" : " (Oct)",
    "Nov" : " (Nov)",
    "Dec" : " (Dec)",

}

const dataConsiderations = ref({
    cas : {
        model:false
    },
    aliquotsSand: {
        model:false
    },
    boemSand :{
        model:false
    },
    CABI:{
        model: false
    },
    CABE:{
        model: false
    },
    ART:{
        model: false
    },
    PIPE:{
        model: false
    },
    shipping:{
        model: false
    },
    commFishing:{
        model: false
    },

})

const infoDialogs = ref({
    about:{
        pName: "About These Data",
        model: false,
        text: "More info about the importance of coastal marshes."
    },
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "More info about the importance of coastal marshes."
    },
    ART:{
        pName: "Artificial Reefs",
        model: false,
        text: "Artificial reefs estimated within the area of interest. Data originates from Paxton et al. 2023."
    },
    PIPE:{
        pName: "Pipelines",
        model: false,
        text: "Oil and gas pipelines within the area of interest. Data originates form the Office for Coastal Management. "
    },
    aliquots:{
        pName: "OCS Aliquots with sand resources",
        model: false,
        text: "Outer Continental Shelf (OCS) block aliquots (1/16th of OCS protraction grid block) in the BOEM Atlantic Ocean Region that lie at least partially within a 1 statute mile buffer of where OCS sand resources have been identified through reconnaissance and/or design-level studies."
    },
    boem:{
        pName: "BOEM sand resources",
        model: false,
        text: "Areas on the Outer Continental Shelf (OCS) and (if available) nearshore areas where there is some likelihood that a usable sand resource exists. "
    },
    CABE:{
        pName: "Export Cables",
        model: false,
        text: "These lines represent the installed or proposed locations of the 'Export Cable' portions of a wind farm based on the developers current plans. Source of this data in the Marine Cadastre. "
    },
    CABI:{
        pName: "Inter-array Cables",
        model: false,
        text: "This dataset shows proposed and installed inter-array cables for offshore wind projects. Source of this data in the Marine Cadastre."
    },
    shipping:{
        pName: "Shipping and Commercial Fishing",
        model: false,
        text: "Overall shipping and Commercial Fishing within the area of interest. Data from 2023. Only vessels with Automatic Identification System (AIS) are included. Thresholds calculated across the region using percentiles of all potential values over time. Data originates from the Marine Cadastre and GlobalFishWatch. "
    }

})

onMounted(() => {
    if (activeLayerID.value != 'PEOPLE_OTHER'){
        loadDataByID('PEOPLE_OTHER', version)
    }
    // const mapStyle = processedData.value['mapStyle'];
    // if (mapStyle) {

    //     otherAttrClick(mapStyleInfo.value['attr'], "")

    // }
    
})
</script>
<style scoped>
.highlight{
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    border: 1px solid black;
    margin: 3px;
    border-radius: 3px;
    position: relative;
    z-index: 10;
    /* margin-right: 3px; */
    /* padding-bottom:0px; */
    min-height: 12px !important; 
}
.mapActive{
    background-color: #1D8177;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
</style>